module.exports = __webpack_public_path__ + "static/brownknitted-f28c995eb8af1474fa0360ed4e22ae93.jpeg";